export default __webpack_public_path__ + "static/media/dis23-f.29173295.pdf";